import React, { useState } from 'react'
import PropTypes from 'prop-types'
import CustomChart from './CustomChart'
import { useAttendedRequest } from '../../../../hooks/feature/statistic/useAttendedRequest'
import { downloadTypes } from '../../../../constants/statistics'

const AttendedRequestsChart = ({ results = {} }) => {
  const [chartType, setChartType] = useState('PieChart')
  const { chartData, chartTitle } = useAttendedRequest(results, chartType)

  const handleChartTypeChange = value => {
    setChartType(value)
  }

  return (
    <CustomChart
      chartData={chartData}
      onChangeChartType={handleChartTypeChange}
      typesChart={['PieChart', 'BarChart']}
      horizontalTitle="Días hábiles"
      verticalTitle="Número de solicitudes"
      title={chartTitle.title}
      chartTitle={chartTitle.chartTitle}
      description={chartTitle.description}
      excelKindDownload="attended_requests"
      downloadAvailable={[downloadTypes.picture, downloadTypes.excel]}
    />
  )
}

export default AttendedRequestsChart

AttendedRequestsChart.propTypes = {
  results: PropTypes.object.isRequired
}
